/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetCategoryDataFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetCategoryDataFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import type { getCategoryData } from '.';

export const getCategoryDataDataMock: GetCategoryDataFragmentFragment = {
  breadCrumb: [
    { name: 'Damenmode', id: '1' },
    { name: 'Shirts', id: '2' },
  ],
};

export const getCategoryDataReturnMock: ReturnType<typeof getCategoryData> = {
  categoryPath: getCategoryDataDataMock.breadCrumb!,
  categoryPathAsString: `${getCategoryDataDataMock.breadCrumb![0].name}/${
    getCategoryDataDataMock.breadCrumb![1].name
  }`,
};

export function getgetCategoryDataFragmentedData(data?: GetCategoryDataFragmentFragment) {
  return makeFragmentData(data || getCategoryDataDataMock, GetCategoryDataFragmentFragmentDoc);
}
